import { Controller } from "@hotwired/stimulus"

// Retargets the single shared report modal when a flag button is clicked, so
// the page carries one modal rather than one per post. Bootstrap still does the
// opening via data-bs-toggle; this only fills in what is being reported.
export default class extends Controller {
  static targets = ["form", "type", "id", "label"]

  prepare(event) {
    const { type, id, label } = event.params

    this.typeTarget.value = type
    this.idTarget.value = id

    if (this.hasLabelTarget) this.labelTarget.textContent = label || ""
  }
}
